"use client";
import {
  AgendaCardButton,
  AgendaCardLayout
} from "@gettactic/components/src/components/reservation-card/AgendaCardLayout";
import { UserCheck } from "lucide-react";
import React from "react";

export interface DedicatedDeskCardProps {
  deskName: string;
  /** Opens (or closes) the desk in the dashboard's details column. */
  onSelect?: () => void;
  isSelected?: boolean;
}

/**
 * The agenda's card for a person's own dedicated desk on a day they are at
 * its office: there is nothing to reserve, the desk is theirs. Days the desk
 * is released to others do not get the card at all. Clicking it shows the
 * desk's details, where it sits on the map and the days it is released.
 */
export const DedicatedDeskCard: React.FC<DedicatedDeskCardProps> = ({
  deskName,
  onSelect,
  isSelected = false
}) => {
  return (
    <AgendaCardLayout
      onCardClick={onSelect}
      hasHover={!!onSelect}
      isSelected={isSelected}
      topLeft={
        <div className="flex items-center gap-1.5">
          <UserCheck className="size-4 text-neutral-500" />
          <span className="font-inter font-medium">{deskName}</span>
        </div>
      }
      bottomLeft={
        <div className="font-inter text-[13px] text-neutral-600">
          Your dedicated desk — no need to reserve
        </div>
      }
      button={
        onSelect ? (
          <AgendaCardButton variant={"secondaryDashboard"} onClick={onSelect}>
            {isSelected ? "Hide details" : "View details"}
          </AgendaCardButton>
        ) : null
      }
    />
  );
};
